import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Slim auto-rotating banner at the top of every page.
 * Hides itself if no active ads in the "top_banner" placement.
 * Rotates every 6 seconds with a clean fade.
 */
const TopBannerAd = () => {
  const [ads, setAds] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/ads/active`)
      .then((res) => {
        if (cancelled) return;
        const list = (res.data && res.data.top_banner) || [];
        setAds(list);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (ads.length <= 1) return;
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % ads.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [ads.length]);

  if (!ads || ads.length === 0) return null;

  const ad = ads[index];

  return (
    <a
      href={ad.destination_url || '#'}
      target="_blank"
      rel="noopener sponsored noreferrer"
      data-testid="top-banner-ad"
      className="block w-full bg-[#0F0F0F] border-b border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-colors"
      aria-label={`Sponsored: ${ad.brand_name}`}
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3">
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#737373] font-medium shrink-0">
          Sponsored
        </span>
        {ad.ad_image_url && (
          <img
            src={ad.ad_image_url}
            alt={ad.brand_name}
            className="h-7 max-w-[120px] object-contain shrink-0"
          />
        )}
        <span className="text-sm text-[#E5E5E5] truncate">
          {ad.headline || ad.brand_name}
        </span>
        <span className="text-xs text-[#D4AF37] ml-auto shrink-0">
          {ad.cta_text || 'Visit'} &rarr;
        </span>
      </div>
    </a>
  );
};

export default TopBannerAd;
